export const APP_ENV_TYPES = {
  LOCAL: "local",
  DEV: "dev",
  PREPROD: "preprod",
  STAGING: "staging",
  PRODUCTION: "production",
} as const;
type AppEnvKeys = keyof typeof APP_ENV_TYPES;
export type AppEnvType = (typeof APP_ENV_TYPES)[AppEnvKeys];

export const currentAppEnv: AppEnvType =
  (process.env.REACT_APP_ENVIRONMENT as AppEnvType) || APP_ENV_TYPES.LOCAL;

export const isProdEnv = currentAppEnv === APP_ENV_TYPES.PRODUCTION;
export const isStagingEnv = currentAppEnv === APP_ENV_TYPES.STAGING;
export const isPreProdEnv = currentAppEnv === APP_ENV_TYPES.PREPROD;
export const isDevEnv = currentAppEnv === APP_ENV_TYPES.DEV;
export const isLocalEnv = currentAppEnv === APP_ENV_TYPES.LOCAL;
